import React, { Component } from 'react';

import { ResponsivePie } from '@nivo/pie';
import { AutoSizer } from 'react-virtualized';

// [
//   {
//     "id": "haskell",
//     "label": "haskell",
//     "value": 52,
//     "color": "hsl(15, 70%, 50%)"
//   },
//   {
//     "id": "python",
//     "label": "python",
//     "value": 137,
//     "color": "hsl(116, 70%, 50%)"
//   },
//   {
//     "id": "lisp",
//     "label": "lisp",
//     "value": 303,
//     "color": "hsl(125, 70%, 50%)"
//   },
//   {
//     "id": "rust",
//     "label": "rust",
//     "value": 115,
//     "color": "hsl(65, 70%, 50%)"
//   },
//   {
//     "id": "ruby",
//     "label": "ruby",
//     "value": 498,
//     "color": "hsl(124, 70%, 50%)"
//   }
// ]


class PieChart extends Component {
  fillData = [
    {
        "match": {
            "id": "ruby"
        },
        "id": "dots"
    },
    {
        "match": {
            "id": "scala"
        },
        "id": "lines"
    },
  ];

  fillDefs = [
    {
        "id": "dots",
        "type": "patternDots",
        "background": "inherit",
        "color": "rgba(255, 255, 255, 0.3)",
        "size": 4,
        "padding": 1,
        "stagger": true
    },
    {
        "id": "lines",
        "type": "patternLines",
        "background": "inherit",
        "color": "rgba(255, 255, 255, 0.3)",
        "rotation": -45,
        "lineWidth": 6,
        "spacing": 10
    }
  ];

  render() {
    const { data } = this.props;

    return (
      <div style={{ flex: '1 1 auto', height: '100%', minHeight: 400 }}>
        <AutoSizer>
          {({ height, width }) => (
            <div style={{height: height, width: width}}>
              <ResponsivePie
                data={data}
                margin={{
                    "top": 0,
                    "right": 0,
                    "bottom": 100,
                    "left": 100
                }}
                innerRadius={0}
                padAngle={0.7}
                cornerRadius={3}
                colors="nivo"
                colorBy="id"
                borderWidth={1}
                borderColor="inherit:darker(0.2)"
                radialLabelsSkipAngle={10}
                radialLabelsTextXOffset={6}
                radialLabelsTextColor="#333333"
                radialLabelsLinkOffset={0}
                radialLabelsLinkDiagonalLength={16}
                radialLabelsLinkHorizontalLength={24}
                radialLabelsLinkStrokeWidth={1}
                radialLabelsLinkColor="inherit"
                slicesLabelsSkipAngle={10}
                slicesLabelsTextColor="#333333"
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                theme={{
                    "tooltip": {
                        "container": {
                            "fontSize": "13px"
                        }
                    },
                    "labels": {
                        "textColor": "#555"
                    }
                }}
                defs={this.fillDefs}
                fill={this.fillData}
              />
            </div>
          )}
        </AutoSizer>
      </div>
    )
  }
}

export default PieChart;



// WEBPACK FOOTER //
// ./src/views/Project/PieChart/PieChart.js